import { Component, inject, OnDestroy, signal, Signal, WritableSignal } from '@angular/core';
import { stages } from '../../agreement-on-terms-rules-bus-stops.routes';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ApplicationAppEntityApplicationRead,
  BusStopAppEntityBusStopWrite
} from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BusStopItemForm } from './forms/bus-stop.item.form';
import { BusStopItemFormComponent } from './components/bus-stop-item-form/bus-stop-item-form.component';
import { BusStopsPreviewComponent } from './components/bus-stops-preview/bus-stops-preview.component';
import {
  ParcelItemFormComponent
} from '../../../common/components/parcels/parcel-item-form/parcel-item-form.component';
import { ParcelsPreviewComponent } from '../../../common/components/parcels/parcels-preview/parcels-preview.component';
import { updateBusStops } from '../../../../../../store/actions/application.actions';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-list-of-stops-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    BusStopItemFormComponent,
    BusStopsPreviewComponent
  ],
  providers: [BusStopItemForm],
  templateUrl: './list-of-stops-section.component.html'
})
export class ListOfStopsSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public form: BusStopItemForm = inject(BusStopItemForm);

  public showItemForm = true;

  public currentIndex: number | undefined = undefined;

  public listOfStops: WritableSignal<BusStopAppEntityBusStopWrite[]> = signal<BusStopAppEntityBusStopWrite[]>([]);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(application => {
    const items: BusStopAppEntityBusStopWrite[] = application?.busStops?.map(v => {
      return {
        roadNumber: `${v?.roadNumber || ''}`,
        stopName: `${v?.stopName || ''}`,
        roadSide: `${v?.roadSide || ''}`,
        stopNumber: `${v?.stopNumber || ''}`,
        location: `${v?.location || ''}`
      };
    }) || [];
    this.listOfStops.set(items);
    if (items.length) {
      this.showItemForm = false;
    }
  });

  public onRemoveItem(index: number): void {
    this.listOfStops.update(v => v.filter((_, i) => i !== index));
    if (!this.listOfStops().length) {
      this.showItemForm = true;
    }
  }

  public onSubmitItemForm(value: BusStopAppEntityBusStopWrite): void {
    if (this.currentIndex !== undefined) {
      this.listOfStops.update((v: BusStopAppEntityBusStopWrite[]) => {
        let items = [...v];
        if (this.currentIndex !== undefined) {
          items[this.currentIndex] = { ...value };
        }
        return items;
      });
    } else {
      this.listOfStops.update(v => [...v, { ...value }]);
    }
    this.currentIndex = undefined;
    this.showItemForm = false;
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    const application = this.application();
    if (application && this.listOfStops().length) {
      this.store$.dispatch(updateBusStops({
          application,
          listOfStops: this.listOfStops(),
          successFnc: () => {
            this.router.navigate(
              ['../zgody'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
